import {
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
} from '../../interface/interface';

export const handleShippedStatus = (
  groups: unknown,
  allOrderStatus: OrderSelectionOptionItem[],
  commonAdminStatuses: OrderStatusCode[],
) => {
  if ((groups as string[])[0] === ROLE.Pharmacist) {
    return allOrderStatus.filter((e) =>
      [OrderStatusCode.READY_FOR_SHIPPING].includes(e?.id),
    );
  } else if ((groups as string[])[0] === ROLE.Admin) {
    return allOrderStatus.filter((e) => commonAdminStatuses.includes(e?.id));
  } else {
    return [];
  }
};
